// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { Icon } from 'iconsax-react';

const ChangeOfAgencyIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M5.83333 7.66667C4.17667 7.66667 2.83333 6.32333 2.83333 4.66667C2.83333 3.01 4.17667 1.66667 5.83333 1.66667C7.49 1.66667 8.83333 3.01 8.83333 4.66667C8.83333 6.32333 7.49 7.66667 5.83333 7.66667ZM5.83333 2.66667C4.73 2.66667 3.83333 3.56333 3.83333 4.66667C3.83333 5.77 4.73 6.66667 5.83333 6.66667C6.93667 6.66667 7.83333 5.77 7.83333 4.66667C7.83333 3.56333 6.93667 2.66667 5.83333 2.66667Z" fill={color || 'currentColor'} />
      <path d="M10.5 14.3333H1.16667C0.893333 14.3333 0.666667 14.1067 0.666667 13.8333C0.666667 11.26 2.98 9.16667 5.83333 9.16667C6.43333 9.16667 7.02 9.26 7.57 9.44667C7.83 9.53333 7.97333 9.81333 7.88667 10.0733C7.8 10.3333 7.51333 10.4733 7.26 10.39C6.81333 10.2367 6.33333 10.1667 5.83333 10.1667C3.69333 10.1667 1.93333 11.6133 1.69333 13.3333H10.5C10.7733 13.3333 11 13.56 11 13.8333C11 14.1067 10.7733 14.3333 10.5 14.3333Z" fill={color || 'currentColor'} />
      <path d="M11.6667 14.3333C11.5333 14.3333 11.4 14.28 11.3133 14.1933L9.31333 12.1933C9.12 12 9.12 11.6733 9.31333 11.48L11.3133 9.48C11.5067 9.28667 11.8333 9.28667 12.0267 9.48C12.22 9.67333 12.22 10 12.0267 10.1933L10.7133 11.5067H14.6667C14.94 11.5067 15.1667 11.7333 15.1667 12.0067C15.1667 12.28 14.94 12.5067 14.6667 12.5067H10.7133L12.0267 13.82C12.22 14.0133 12.22 14.34 12.0267 14.5333C11.9333 14.6267 11.8 14.3333 11.6667 14.3333Z" fill={color || 'currentColor'} />
    </svg>
  );
};

export { ChangeOfAgencyIcon };
